export default angular
  .module("CodeSystemService", [])
  .factory("CodeSystem", [
    "$http",
    "$rootScope",
    "$filter",
    "Flash",
    function ($http, $rootScope, $filter, Flash) {
      const loading = {
        codeSystems: false,
        codeSystem: false,
      };

      const addCodeSystem = (callback) => {
        const params = {
          NAME: `new-code-system-${(new Date()).getTime()}`,
        };
        $http
          .post("/api/code-systems", params)
          .then(
            (res) => {
              const successMessage = `New Code System created, ID: ${res.data.id}`;
              Flash.create("success", successMessage, "basicAlert");
              callback(res.data, res.status);
            },
            (res) => {
              if (res.status === 409) {
                const warningMessage = "Conflict! Code System with the same name already exists. Update aborted!";
                Flash.create("warning", warningMessage, "basicAlert");
              } else {
                const errorMessage = `Error! Updating Code System failed. Error code: ${res.status}`;
                Flash.create("danger", errorMessage, "basicAlert");
              }
              callback(res.data, res.status);
            },
          );
      };

      const updateCodeSystem = (record, callback) => {
        $http
          .put(`/api/code-systems/${record.ID}`, record)
          .success((data, status) => {
            const successMessage = `Updated Code System, Id: ${data.id}`;
            Flash.create("success", successMessage, "basicAlert");
            if (callback) {
              callback(data, status);
            }
          })
          .error((data, status) => {
            const errorMessage = `Error! Updating Code System failed. Error code: ${status}`;
            Flash.create("danger", errorMessage, "basicAlert");

            if (callback) {
              callback(data, status);
            }
          })
          .finally(() => {});
      };

      const deleteCodeSystemById = (id, callback) => {
        $http
          .delete(`/api/code-systems/${id}`)
          .then(
            () => {
              const successMessage = "Remove successful for Code System";
              Flash.create("success", successMessage, "basicAlert");
              if (callback) {
                callback();
              }
            },
            (res) => {
              const errorMessage = `Error! Removing Code System failed with error code: ${res.status}`;
              Flash.create("danger", errorMessage, "basicAlert");
              if (callback) {
                callback();
              }
            },
          );
        if (callback) {
          callback();
        }
      };

      // Load all CodeSystems from the database
      const loadCodeSystems = (callback) => {
        loading.codeSystems = true;
        $http
          .get("/api/code-systems")
          .success((data, status) => {
            if (callback) {
              callback(data, status);
            }
          })
          .error((data, status) => {
            // display error message to user
            const errorMessage = `Error! ${data.errortext} Error code: ${status}`;
            Flash.create("danger", errorMessage, "basicAlert");

            if (callback) {
              callback(data, status);
            }
          }).finally(() => {
            loading.codeSystems = false;
          });
      };

      // Load a CodeSystem by id
      const loadCodeSystemById = (id, callback) => {
        loading.codeSystem = true;
        $http
          .get(`/api/code-systems/${id}`)
          .success((data, status) => {
            if (callback) {
              callback(data, status);
            }
          })
          .error((data, status) => {
            // Show error message to a user
            const errorMessage = `Error! ${data.errortext} Error code: ${status}`;
            Flash.create("danger", errorMessage, "basicAlert");

            if (callback) {
              callback(data, status);
            }
          })
          .finally(() => { loading.codeSystem = false; });
      };

      return {
        addCodeSystem,
        updateCodeSystem,
        deleteCodeSystemById,
        loading,
        loadCodeSystems,
        loadCodeSystemById,
      };
    },
  ]);
